<app-navbar-style-two></app-navbar-style-two>

<!-- Enhanced Page Banner -->
<div class="page-banner-area enhanced-banner">
    <div class="banner-bg-overlay"></div>
    <div class="container-fluid blog-banner">
        <div class="overlay"></div>
        <div class="page-banner-content">
            <h1 class="display-3 fw-bold mb-3">Latest Insights & News</h1>
            <p class="lead mb-4">Stay updated with the latest trends in business communication and technology</p>
            <ul class="breadcrumb">
            <li><a routerLink="/">Home</a></li>
            <li>Blog</li>
            </ul>
        </div>
    </div>

    <div class="shape-1">
        <img src="assets/img/shape/shape1.png" alt="Shape">
    </div>
    <div class="shape-2">
        <img src="assets/img/shape/shape2.png" alt="Shape">
    </div>
    <div class="shape-3">
        <img src="assets/img/shape/shape3.png" alt="Shape">
    </div>
</div>

<!-- Blog Area -->
<div class="blog-area ptb-100">
    <div class="container">
        <!-- Loading Spinner -->
        <div *ngIf="loading" class="text-center py-5">
            <div class="spinner">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
            </div>
            <p class="mt-3">Loading articles...</p>
        </div>

        <!-- Error Message -->
        <div *ngIf="error" class="alert alert-danger" role="alert">
            <i class="fas fa-exclamation-circle me-2"></i>
            An error occurred while loading the blog posts. Please try again later.
        </div>

        <!-- Blog Content -->
        <div *ngIf="!loading && !error" class="row">
            <!-- Blog Posts -->
            <div class="col-lg-8">
                <div class="row">
                    <div *ngFor="let blog of blogs" class="col-lg-6 col-md-6">
                        <div class="single-blog-card enhanced-card">
                            <div class="blog-image">
                                <a [routerLink]="['/blogs', blog.slug]">
                                    <img [src]="blog.image" [alt]="blog.title" class="img-fluid">
                                </a>
                                <div class="category-tag">
                                    <a href="javascript:void(0)" (click)="filterByCategory(blog.category)">
                                        {{blog.category}}
                                    </a>
                    </div>
                </div>
                            <div class="blog-content">
                                <div class="meta-info d-flex align-items-center mb-2">
                                    <div class="author-avatar me-2">
                                        <span class="avatar-initials">{{ getAuthorInitials(blog) }}</span>
            </div>
                                    <ul class="mb-0">
                                        <li>
                                            <i class="far fa-calendar-alt"></i>
                                            {{blog.date | date:'mediumDate'}}
                                        </li>
                                        <li>
                                            <i class="far fa-user"></i>
                                            {{blog.author}}
                                        </li>
                        </ul>
                                </div>
                                <h3>
                                    <a [routerLink]="['/blogs', blog.slug]">{{blog.title}}</a>
                                </h3>
                                <p>{{blog.summary}}</p>
                                <div class="blog-tags mb-2">
                                    <span *ngFor="let tag of blog.tags" class="tag-chip">{{tag}}</span>
                    </div>
                                <a [routerLink]="['/blogs', blog.slug]" class="read-more-btn prominent">
                                    Read More <i class="fas fa-arrow-right"></i>
                                </a>
                </div>
                    </div>
                </div>
            </div>

                <!-- Load More Button -->
                <div *ngIf="currentPage < lastPage" class="text-center mt-4">
                    <button 
                        (click)="loadMore()" 
                        class="load-more-btn" 
                        [disabled]="loadingMore">
                        <span *ngIf="!loadingMore">
                            <i class="fas fa-sync-alt me-2"></i>Load More Articles
                        </span>
                        <span *ngIf="loadingMore">
                            <i class="fas fa-spinner fa-spin me-2"></i>Loading...
                        </span>
                    </button>
                </div>
            </div>

            <!-- Sidebar -->
            <div class="col-lg-4">
                <aside class="widget-area">
                    <!-- Categories Widget -->
                    <div class="widget widget_categories">
                        <h3 class="widget-title">Categories</h3>
                        <ul>
                            <li [class.active]="selectedCategory === null">
                                <a href="javascript:void(0)" 
                                   (click)="filterByCategory(null)">
                                    All Categories
                                    <span class="count">({{blogs.length}})</span>
                                </a>
                            </li>
                            <li *ngFor="let category of categories" 
                                [class.active]="selectedCategory === category.name">
                                <a href="javascript:void(0)" 
                                   (click)="filterByCategory(category.name)">
                                    {{category.name}}
                                    <span class="count">({{category.count}})</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <!-- Popular Tags -->
                    <div class="widget widget_tag_cloud">
                        <h3 class="widget-title">Popular Tags</h3>
                        <div class="tagcloud">
                            <a href="javascript:void(0)" *ngFor="let tag of getPopularTags()">
                                {{tag}}
                            </a>
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>